/* eslint camelcase: 0 */
import { Area } from '@/infrastructure/network/Monitaro/schema/models'
import { IAreaProps, EmptyAreaPropsFactory } from '@/entities/Area'

export const toAreaProps = (props: Area | null | undefined): IAreaProps => {
  if (!props) {
    return EmptyAreaPropsFactory()
  }

  const { id, name, zeacon, type, hospital_id, hospital, approval, chargeable, properties, flags, created_at, updated_at } = props

  return EmptyAreaPropsFactory({
    id,
    name,
    zeacon,
    type,
    hospitalId: hospital_id,
    hospital,
    approval,
    chargeable,
    properties,
    flags,
    createdAt: created_at,
    updatedAt: updated_at
  })
}
